<template>
    <header>
      <img src="../assets/img/logo.png" alt="Life in Mobile"/>
    </header>
</template>

<script>
    export default {
      name: 'Header',
      props: {
        msg: String
      }
    }
</script>

<style scoped>
</style>
